
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 31 25"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_40572","data-name":"Group 40572","transform":"translate(-1599 -825)","fill":"none","stroke-width":"1.5"}},[_c('g',{attrs:{"id":"Rectangle_13067","data-name":"Rectangle 13067","transform":"translate(1599 825)","stroke":"#5a677c"}},[_c('rect',{attrs:{"width":"31","height":"25","rx":"6","stroke":"none"}}),_c('rect',{attrs:{"x":".75","y":".75","width":"29.5","height":"23.5","rx":"5.25"}})]),_c('line',{attrs:{"id":"Line_1133","data-name":"Line 1133","x2":"30","transform":"translate(1599.5 830.5)","stroke":"#5a677c"}}),_c('g',{attrs:{"id":"Group_40571","data-name":"Group 40571","transform":"translate(-.463)","stroke":"#5a677b","stroke-linecap":"round"}},[_c('line',{attrs:{"id":"Line_1134","data-name":"Line 1134","x1":"2","y2":"7","transform":"translate(1613.5 836.5)"}}),_c('path',{attrs:{"id":"Path_29075","data-name":"Path 29075","d":"M0 0l2.335 2.616L0 5","transform":"translate(1618.202 837.5)","stroke-linejoin":"round"}}),_c('path',{attrs:{"id":"Path_29076","data-name":"Path 29076","d":"M0 0l2.335 2.616L0 5","transform":"rotate(180 805.399 421.25)","stroke-linejoin":"round"}})])])])
          )
        }
      }
    